<app-form-section headerKey="template.type">
  <app-select-input [formControl]="templateControl" [options]="templateSelect" [footer]="false"></app-select-input>
</app-form-section>
<ng-container *ngIf="selected != null">
  <ng-container *ngIf="!isEmpty(form.controls)">
    <div [formGroup]="form" class="grid-50-50">
      <ng-container *ngFor="let keyValue of selected.mergeFields | keyvalue; let last = last">
        <ng-container *ngIf="keyValue.value as field">
          <app-form-section [headerKey]="field.label | capitalize" [sectionOptions]="['req', 'noDiv', 'pad']">
            <ng-container [ngSwitch]="field.type">
              <ng-container *ngSwitchCase="FieldType.TEXT">
                <app-text-input [formControlName]="field.id" [footer]="false"></app-text-input>
              </ng-container>
              <ng-container *ngSwitchCase="FieldType.NUMBER">
                <app-text-input [formControlName]="field.id" type="number" [footer]="false"></app-text-input>
              </ng-container>
              <ng-container *ngSwitchCase="FieldType.DATE">
                <app-date-input [formControlName]="field.id" [footer]="false"></app-date-input>
              </ng-container>
              <ng-container *ngSwitchCase="FieldType.DATE_TIME">
                <app-date-input [formControlName]="field.id" [hours]="true" [footer]="false"></app-date-input>
              </ng-container>
              <ng-container *ngSwitchCase="FieldType.TIME">
                <app-time-input [formControlName]="field.id" [footer]="false"></app-time-input>
              </ng-container>
            </ng-container>
          </app-form-section>
        </ng-container>
      </ng-container>
    </div>
    <mat-divider class="margin-bottom-15"></mat-divider>
  </ng-container>
  <ng-container *ngFor="let field of fieldsVM; let last = last">
    <app-form-section [headerKey]="field.labelKey" [sectionOptions]="last ? ['noDiv'] : ['noDiv', 'pad']">
      <div class="template-container" [innerHTML]="displayFields[field.name]"></div>
    </app-form-section>
  </ng-container>
</ng-container>
